import { render, staticRenderFns } from "./sipserver.vue?vue&type=template&id=89c65fdc&scoped=true"
import script from "./sipserver.vue?vue&type=script&lang=js"
export * from "./sipserver.vue?vue&type=script&lang=js"
import style0 from "./sipserver.vue?vue&type=style&index=0&id=89c65fdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89c65fdc",
  null
  
)

export default component.exports